<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="m9.671 17.386 3.364 3.572 2.623-4.233 6.96-.768-1.123-12.229-20.111 2.22 1.123 12.229 7.164-.79Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
